import React from 'preact';
import { useEffect } from "preact/compat";
import { useState } from "preact/hooks";
import constants from '../../constants';

interface FourColumnsProps {
  active: boolean;
}

export default function FourColumns({ active }: FourColumnsProps) {
  const [primaryColor, setPrimaryColor] = useState('');
  const [secondaryColor, setSecondaryColor] = useState('');

  useEffect(() => {
    if (active) {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_ACTIVE);
      setSecondaryColor(constants.PRICE_COLOR_PRIMARY_ACTIVE);
    } else {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_INACTIVE);
      setSecondaryColor(constants.COLUMN_COLOR_SECONDARY_INACTIVE);
    }
  }, [active]);

  return (
    <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 27.94">
      <g id="Layer_1-2">
        <path fill={primaryColor} d="M8.43,0H.18c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32V.32c0-.18-.08-.32-.18-.32h0Z" />
        <path fill={secondaryColor} d="M8.43,16.72H.18c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
        <path fill={primaryColor} d="M8.43,25.09H.18c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
        <path fill={secondaryColor} d="M8.43,8.37H.18c-.1,0-.18.14-.18.31v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32h0Z" />
        <path fill={primaryColor} d="M20.89,0h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32V.32c0-.18-.08-.32-.18-.32h0Z" />
        <path fill={secondaryColor} d="M20.89,16.72h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z"  />
        <path fill={primaryColor} d="M20.89,25.09h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
        <path fill={secondaryColor} d="M20.89,8.37h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
        <path fill={primaryColor} d="M33.36,0h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32V.32c0-.18-.08-.32-.18-.32Z" />
        <path fill={secondaryColor} d="M33.36,16.72h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
        <path fill={primaryColor} d="M33.36,25.09h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
        <path fill={secondaryColor} d="M33.36,8.37h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
        <path fill={primaryColor} d="M45.82,0h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32V.32c0-.18-.08-.32-.18-.32h0Z" />
        <path fill={secondaryColor} d="M45.82,16.72h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
        <path fill={primaryColor} d="M45.82,25.09h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
        <path fill={secondaryColor} d="M45.82,8.37h-8.25c-.1,0-.18.14-.18.32v2.21c0,.18.08.32.18.32h8.25c.1,0,.18-.14.18-.32v-2.21c0-.18-.08-.32-.18-.32Z" />
      </g>
    </svg>
  );
}